module.exports = __webpack_public_path__ + "static/media/aiesec_logo.18f3c1c8.png";